










import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import { User } from "../../models";

@Component({ components: { VSelect } })
export default class UserTitleSelect extends Vue {
  @Prop({ required: true })
  readonly selected!: string | null;

  @Prop({ required: true })
  readonly placeholder!: string | null;

  @Prop()
  readonly queryKey?: string;

  @Prop({ default: false })
  readonly preselect: boolean;

  @Prop({ default: false })
  readonly actsAsFilter: boolean;

  options: VSelectOption[] = [];

  private value: string | null = this.selected || null;

  mounted() {
    this.loadItems();
  }

  onSelected(id: string) {
    this.value = id;
    this.$emit("input", id);

    if (this.queryKey && this.$route.query[this.queryKey] !== this.value) {
      let query = this.$route.query;
      query[this.queryKey] = this.value;

      this.$router.push({ query });
    }
  }

  loadItems() {
    if (this.actsAsFilter) {
      this.options = [{ id: "all", text: "All" }];
    }

    this.options.push(
      ...User.titles.map((o) => {
        return { id: o.id, text: o.name };
      })
    );
    if (!this.value) {
      if (this.preselect) {
        this.value = this.options[0].id;
      }
    } else {
      this.value = this.options.find((o) => o.id === this.selected)?.id;
    }
  }
}
